import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { NotificationType } from 'src/app/enum/notification-type.enum';
import { OnlineCalcModel } from 'src/app/models/onlinecalc/onlinecalc.model';
import { AuthGaurdService } from 'src/app/service/auth-gaurd.service';
import { NotificationService } from 'src/app/service/notification.service';
import { OnlineCalcService } from 'src/app/service/onlinecalc.service';
import { startWith, map } from 'rxjs/operators';
import { ErrorResponseMessage } from 'src/app/error-handler/error-response-message.model';
import { GlobalService } from 'src/app/service/global.service';
import * as moment from 'moment';

@Component({
  selector: 'app-managecalc',
  templateUrl: './managecalc.component.html',
  styleUrls: ['./managecalc.component.css']
})
export class ManagecalcComponent implements OnInit {

  constructor(private globalService: GlobalService, private router: Router, private onlineCalcService: OnlineCalcService,
    private authGaurdService: AuthGaurdService, private notificationService: NotificationService) { }

  public onlineCalcModel = new OnlineCalcModel();
  public onlineCalcModel1 = new OnlineCalcModel();
  public onlineCalcModel2 = new OnlineCalcModel();

  salesChannelData: OnlineCalcModel[] = [];
  selctedCommPlans: OnlineCalcModel[] = [];
  calcData: OnlineCalcModel[] = [];
  cData: OnlineCalcModel[] = [];
  filteredSalesChannelsData: OnlineCalcModel[] = [];
  filteredSalesChannelValues: Observable<OnlineCalcModel[]> | undefined;
  controlSc = new FormControl();
  selectedCommIds: string = "";
  selectedIds: string = "";
  rest: string = "";
  restid: string = "";
  masterSelected: boolean;
  public loggedinUser: string = "";
  public selectedEmpsPushData: OnlineCalcModel[] = [];

  salesChannel: string = "";
  calRunId: number = 0;

  salesCh: string = "";
  calId: string = "";

  calRunIdsData: OnlineCalcModel[] = [];
  filteredCalRunIdsData: OnlineCalcModel[] = [];
  filteredCalRunIdsValues: Observable<OnlineCalcModel[]> | undefined;
  controlCalRunIds = new FormControl();

  isAccessDisabled: boolean = false;
  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';

  ngOnInit(): void {
    //Get Permissions
    this.isAccessDisabled = this.globalService._permissionCheck('manage-calc');

    this.loggedinUser = this.authGaurdService.loginUser();
    this.getSalesChannels();
    this.getCalRunIds();
  }

  public getSelectedCals(event: any) {
    console.log("Selected cal run id : " + event.currentTarget.value);
    this.calRunId = event.currentTarget.value;

    this.getData(1);
  }

  public getSelectedSc(event: any) {
    console.log("Selected Sales Channel : " + event.currentTarget.value);
    this.salesChannel = event.currentTarget.value;

    this.getData(1);
  }

  getData(val: number) {
    console.log("getData() called : " + val);
    if (val === 1) {
      console.log("Inside IF");
      console.log(this.onlineCalcModel.salesChannel);
      console.log(this.onlineCalcModel.calRunId);

      if (!this.onlineCalcModel.calRunId) {
        this.notificationService.sendNotification(NotificationType.WARNING, 'Please select cal run ID');
      } else if (!this.onlineCalcModel.salesChannel) {
        this.notificationService.sendNotification(NotificationType.WARNING, 'Please select sales channel');
      } else {
        this.salesCh = this.onlineCalcModel.salesChannel;
        this.calId = this.onlineCalcModel.calRunId;

        this.getCalcData();
      }
    } else {
      if (this.onlineCalcModel.salesChannel) {
        this.salesCh = this.onlineCalcModel.salesChannel;
      }
      if (this.onlineCalcModel.calRunId) {
        this.calId = this.onlineCalcModel.calRunId;
      }
      console.log(this.salesCh);
      console.log(this.calId);

      this.getCalcData();
    }
  }

  getCalcData() {
    this.calcData = [];
    this.onlineCalcService.getCalcData(this.salesCh, this.calId).subscribe(
      (response: OnlineCalcModel[]) => {
        // console.log("response = " + JSON.stringify(response));
        this.calcData = response;
        this.cData = JSON.parse(JSON.stringify(response));
        this.sortColumn = '';
        this.sortDirection = 'asc';
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }

  public updateCalc(calcForm: NgForm) {
    if (!this.onlineCalcModel.calRunId) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please select cal run ID');
    }else if (!this.onlineCalcModel.salesChannel) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please select sales channel');
    } else if (!this.onlineCalcModel1.calc_close_flag) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please select calc close');
    } else {
      this.getCheckedItemList();
      console.log(this.selectedEmpsPushData);
      if (this.selectedEmpsPushData.length === 0) {
        this.notificationService.sendNotification(NotificationType.ERROR, 'Please select the rows');
      } else {
        this.onlineCalcService.updateCalc(this.selectedEmpsPushData)
          .subscribe(response => {
            this.notificationService.sendNotification(NotificationType.SUCCESS, 'Updated Successfully');
            calcForm.reset();
            this.getData(2);

            this.masterSelected = false;
            //response = response as ErrorResponseMessage;
            this.selectedEmpsPushData = [];
          }, (errorResponse: HttpErrorResponse) => {
            var msg: any;
            msg = errorResponse;
            this.notificationService.sendNotification(NotificationType.ERROR, msg);
          })
      }
    }
  }

  // Get List of Checked Items
  getCheckedItemList() {
    console.log("getCheckedItemList() called");
    this.selectedEmpsPushData = [];

    for (var i = 0; i < this.cData.length; i++) {
      if (this.cData[i].editMode) {
        this.onlineCalcModel2 = JSON.parse(JSON.stringify(this.cData[i]));
        this.onlineCalcModel2.adjustment_close_dt = this.onlineCalcModel1.adjustment_close_dt;
        this.onlineCalcModel2.dispute_close_dt = this.onlineCalcModel1.dispute_close_dt;
        this.onlineCalcModel2.calc_close_flag = this.onlineCalcModel1.calc_close_flag;
        this.onlineCalcModel2.comment = this.onlineCalcModel1.comment;
        this.onlineCalcModel2.calRunId = this.calRunId.toString();
        this.onlineCalcModel2.loggedinUser = this.loggedinUser;
        this.selectedEmpsPushData.push(this.onlineCalcModel2);
      }
    }
    //console.log("getCheckedItemList this.selectedEmpsPushData = " + JSON.stringify(this.selectedEmpsPushData));
  }

  // The master checkbox will check/ uncheck all items
  checkUncheckAll() {
    for (var i = 0; i < this.cData.length; i++) {
      this.cData[i].editMode = this.masterSelected;
    }
    this.getCheckedItemList();
  }

  // Check All Checkbox Checked
  isAllSelected() {
    this.masterSelected = this.cData.every(function (item: any) {
      console.log("Edit Mode: isAllSelected");
      return item.editMode == true;
    })
    this.getCheckedItemList();
  }

  sortBy(column: string): void {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }

    const direction = this.sortDirection === 'asc' ? 1 : -1;
    this.cData = [...this.cData].sort((a: any, b: any) => {
      const aVal = this.getSortValue(a[column]);
      const bVal = this.getSortValue(b[column]);

      if (aVal < bVal) {
        return -1 * direction;
      }
      if (aVal > bVal) {
        return 1 * direction;
      }
      return 0;
    });
  }

  private getSortValue(value: any): string | number {
    if (value === null || value === undefined || value === '') {
      return '';
    }

    if (typeof value === 'number') {
      return value;
    }

    const text = String(value).trim();
    const parsedDate = Date.parse(text);
    if (!isNaN(parsedDate) && /[-/]/.test(text)) {
      return parsedDate;
    }

    return text.toLowerCase();
  }

  public getSalesChannels(): void {
    this.onlineCalcService.getSalesChannels().subscribe(
      (response: OnlineCalcModel[]) => {
        this.salesChannelData = response;
        //console.log("this.salesChannelData = " + JSON.stringify(this.salesChannelData));
        this.filteredSalesChannelsData = this.salesChannelData.filter((v, i) => this.salesChannelData.findIndex(item => item.salesChannel != "" && item.salesChannel == v.salesChannel) === i);
        this.filteredSalesChannelsData = this.filteredSalesChannelsData.sort((a, b) => (a.salesChannel < b.salesChannel) ? -1 : 1);
        //console.log("this.filteredSalesChannelsData = "+JSON.stringify(this.filteredSalesChannelsData));
        this.filterSalesChannels();
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }
  filterSalesChannels() {
    this.filteredSalesChannelValues = this.controlSc.valueChanges.pipe(
      startWith(''),
      map(value => this._filterSC(value))
    );
  }
  private _filterSC(value: string) {
    const filterValue = this._normalizeValue(value);
    return this.filteredSalesChannelsData.filter(item => this._normalizeValue(item.salesChannel).includes(filterValue));
  }
  public getSelectedSalesChannels(val: any) {
    var cpdata = "";
    if (val === 0 || val === "" || val === null || val === undefined) {
      cpdata = "";
    } else {
      cpdata = this.filteredSalesChannelsData.find(item => item.salesChannel === val).salesChannel;
    }
    return cpdata;
  }

  public getCalRunIds(): void {
    this.onlineCalcService.getCalRunIds().subscribe(
      (response: OnlineCalcModel[]) => {
        this.calRunIdsData = response;
        //console.log("this.dropDownsData = " + JSON.stringify(this.dropDownsData));
        this.filteredCalRunIdsData = this.calRunIdsData.filter((v, i) => this.calRunIdsData.findIndex(item => item.calRunId != "" && item.calRunId == v.calRunId) === i);
        this.filteredCalRunIdsData = this.filteredCalRunIdsData.sort((a, b) => Number(b.calRunId) - Number(a.calRunId));
        //console.log("this.filteredSalesChannelsData = "+JSON.stringify(this.filteredSalesChannelsData));
        this.filterCalRunIds();
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }
  filterCalRunIds() {
    this.filteredCalRunIdsValues = this.controlCalRunIds.valueChanges.pipe(
      startWith(''),
      map(value => this._filterCalRunId(value))
    );
  }
  private _filterCalRunId(value: string) {
    const filterValue = this._normalizeValue(value);
    return this.filteredCalRunIdsData.filter(item => this._normalizeValue(item.calRunId).includes(filterValue));
  }
  public getSelectedCalRunIds(val: any) {
    var cpdata = "";
    if (val === 0 || val === "" || val === null || val === undefined) {
      cpdata = "";
    } else {
      cpdata = this.filteredCalRunIdsData.find(item => item.calRunId === val).calRunId;
    }
    return cpdata;
  }


  private _normalizeValue(value: string): string {
    if (value)
      return value.toString().toLowerCase().replace(/\s/g, '');
    else
      return '';
  }


}
